// src/routes/protectedRoutes.js
// ✅ 단일 소스 — App.js의 <Routes>가 실제 라우팅에 쓰고, AppLayout.jsx의 keep-alive
// 뱅크가 "탭 전환 시 유지할 페이지 목록"으로 그대로 재사용한다. 여기 추가하면
// 라우팅과 keep-alive 등록이 동시에 되므로 "등록 누락" 자체가 구조적으로 불가능하다.
//
// 여기 없는 것(App.js에 그대로 남겨둔 것):
//  - 리다이렉트 전용 라우트(Navigate) — 실제 페이지가 아니므로 keep-alive 대상이 아님
//  - 동적 파라미터(:id) 라우트 — 이 컴포넌트들은 useParams()로 현재 URL의 파라미터를
//    읽는데, keep-alive 뱅크는 react-router의 실제 매칭 컨텍스트 밖에서 렌더하므로
//    useParams()가 빈 값을 반환한다(react-router <Routes location=...> 오버라이드로
//    해결 가능하나 범위가 넓어 이번 확대 작업에서는 제외 — 아래 EXCLUDED_DYNAMIC_ROUTES
//    참고, 별도 후속 작업으로 남김).
import MyPage from "../pages/MyPage";
import Dashboard from "../pages/Dashboard";

import TaskAssignNew from "../pages/tasks/TaskAssignNew";
import TaskAssignList from "../pages/tasks/TaskAssignList";
import TaskReceivedList from "../pages/tasks/TaskReceivedList";
import TaskByEmployee from "../pages/tasks/TaskByEmployee";
import TaskChatPage from "../pages/tasks/TaskChatPage";

import WorkPerformanceQuickPage from "../pages/work_performance/WorkPerformanceQuickPage";
import WorkPerformanceSummaryPage from "../pages/work_performance/WorkPerformanceSummaryPage";
import WorkPerformanceDashboardPage from "../pages/work_performance/WorkPerformanceDashboardPage";

import EduJob from "../pages/edu/EduJob";
import EduYoutube from "../pages/edu/EduYoutube";
import EduLegal from "../pages/edu/EduLegal";
import EduCert from "../pages/edu/EduCert";

import ExpenseDraftNew from "../pages/approval/ExpenseDraftNew";
import IncomeDraftNew from "../pages/approval/IncomeDraftNew";
import IncomeResolutionNew from "../pages/approval/IncomeResolutionNew";
import ExpenseResolutionNew from "../pages/approval/ExpenseResolutionNew";
import DraftDocumentList from "../pages/draft_document/DraftDocumentList";
import ResolutionList from "../pages/draft_document/ResolutionList";
import ApprovalInbox from "../pages/approval/ApprovalInbox";
import ApprovalInProgress from "../pages/approval/ApprovalInProgress";
import ApprovalCc from "../pages/approval/ApprovalCc";
import LeaveRequestNew from "../pages/approval/LeaveRequestNew";
import LeaveRequestList from "../pages/approval/LeaveRequestList";

import IncomeBusinessNew from "../pages/income/business/IncomeBusinessNew.jsx";
import IncomeBusinessList from "../pages/income/business/IncomeBusinessList.jsx";
import IncomeServiceNew from "../pages/income/service/IncomeServiceNew.jsx";
import IncomeServiceList from "../pages/income/service/IncomeServiceList.jsx";
import GasanIncomeCreate from "../pages/income/cafe/GasanIncomeCreate";
import GasanIncomeList from "../pages/income/cafe/GasanIncomeList";
import DoksanIncomeCreate from "../pages/income/cafe/DoksanIncomeCreate";
import DoksanIncomeList from "../pages/income/cafe/DoksanIncomeList";
import GeumnaraeIncomeCreate from "../pages/income/cafe/GeumnaraeIncomeCreate";
import GeumnaraeIncomeList from "../pages/income/cafe/GeumnaraeIncomeList";
import GreenIncomeCreate from "../pages/income/cafe/GreenIncomeCreate";
import GreenIncomeList from "../pages/income/cafe/GreenIncomeList";
import IncomeEnvTotalNew from "../pages/income/env/total/IncomeEnvTotalNew.jsx";
import EnvTotalList from "../pages/income/env/total/EnvTotalList.jsx";
import IncomeEnvDisinfectionNew from "../pages/income/env/disinfection/IncomeEnvDisinfectionNew.jsx";
import EnvDisinfectionList from "../pages/income/env/disinfection/EnvDisinfectionList.jsx";
import DisinfectionInvoicePage from "../pages/income/env/disinfection/DisinfectionInvoicePage.jsx";

import ExpenseBusinessNew from "../pages/expense/business/ExpenseBusinessNew.jsx";
import ExpenseBusinessList from "../pages/expense/business/ExpenseBusinessList.jsx";
import ExpenseBusinessDraftNew from "../pages/expense/business/ExpenseBusinessDraftNew.jsx";
import ExpenseBusinessDraftList from "../pages/expense/business/ExpenseBusinessDraftList.jsx";
import IncomeBusinessDraftNew from "../pages/income/business/IncomeBusinessDraftNew.jsx";
import IncomeBusinessDraftList from "../pages/income/business/IncomeBusinessDraftList.jsx";
import IncomeEnvTotalDraftNew from "../pages/income/env/total/IncomeEnvTotalDraftNew.jsx";
import IncomeEnvTotalDraftList from "../pages/income/env/total/IncomeEnvTotalDraftList.jsx";
import IncomeEnvDisinfectionDraftNew from "../pages/income/env/disinfection/IncomeEnvDisinfectionDraftNew.jsx";
import IncomeEnvDisinfectionDraftList from "../pages/income/env/disinfection/IncomeEnvDisinfectionDraftList.jsx";
import IncomeServiceDraftNew from "../pages/income/service/IncomeServiceDraftNew.jsx";
import IncomeServiceDraftList from "../pages/income/service/IncomeServiceDraftList.jsx";
import ExpenseTestNew from "../pages/expense/test/ExpenseTestNew.jsx";
import ExpenseTestList from "../pages/expense/test/ExpenseTestList.jsx";
import ExpenseServiceNew from "../pages/expense/service/ExpenseServiceNew.jsx";
import ExpenseServiceList from "../pages/expense/service/ExpenseServiceList.jsx";
import ExpenseServiceDraftNew from "../pages/expense/service/ExpenseServiceDraftNew.jsx";
import ExpenseServiceDraftList from "../pages/expense/service/ExpenseServiceDraftList.jsx";
import ExpenseCafeGasanNew from "../pages/expense/cafe/ExpenseCafeGasanNew.jsx";
import ExpenseCafeGasanList from "../pages/expense/cafe/ExpenseCafeGasanList.jsx";
import ExpenseCafeGasanDraftNew from "../pages/expense/cafe/ExpenseCafeGasanDraftNew.jsx";
import ExpenseCafeGasanDraftList from "../pages/expense/cafe/ExpenseCafeGasanDraftList.jsx";
import ExpenseCafeDoksanNew from "../pages/expense/cafe/ExpenseCafeDoksanNew.jsx";
import ExpenseCafeDoksanList from "../pages/expense/cafe/ExpenseCafeDoksanList.jsx";
import ExpenseCafeDoksanDraftNew from "../pages/expense/cafe/ExpenseCafeDoksanDraftNew.jsx";
import ExpenseCafeDoksanDraftList from "../pages/expense/cafe/ExpenseCafeDoksanDraftList.jsx";
import ExpenseCafeGeumnaraeNew from "../pages/expense/cafe/ExpenseCafeGeumnaraeNew.jsx";
import ExpenseCafeGeumnaraeList from "../pages/expense/cafe/ExpenseCafeGeumnaraeList.jsx";
import ExpenseCafeGeumnaraeDraftNew from "../pages/expense/cafe/ExpenseCafeGeumnaraeDraftNew.jsx";
import ExpenseCafeGeumnaraeDraftList from "../pages/expense/cafe/ExpenseCafeGeumnaraeDraftList.jsx";
import ExpenseCafeGreenNew from "../pages/expense/cafe/ExpenseCafeGreenNew.jsx";
import ExpenseCafeGreenList from "../pages/expense/cafe/ExpenseCafeGreenList.jsx";
import ExpenseCafeGreenDraftNew from "../pages/expense/cafe/ExpenseCafeGreenDraftNew.jsx";
import ExpenseCafeGreenDraftList from "../pages/expense/cafe/ExpenseCafeGreenDraftList.jsx";
import ExpenseEnvDisinfectionNew from "../pages/expense/env/disinfection/ExpenseEnvDisinfectionNew.jsx";
import ExpenseEnvDisinfectionList from "../pages/expense/env/disinfection/ExpenseEnvDisinfectionList.jsx";
import ExpenseEnvDisinfectionDraftNew from "../pages/expense/env/disinfection/ExpenseEnvDisinfectionDraftNew.jsx";
import ExpenseEnvDisinfectionDraftList from "../pages/expense/env/disinfection/ExpenseEnvDisinfectionDraftList.jsx";
import ExpenseEnvTotalNew from "../pages/expense/env/total/ExpenseEnvTotalNew.jsx";
import ExpenseEnvTotalList from "../pages/expense/env/total/ExpenseEnvTotalList.jsx";
import ExpenseEnvTotalDraftNew from "../pages/expense/env/total/ExpenseEnvTotalDraftNew.jsx";
import ExpenseEnvTotalDraftList from "../pages/expense/env/total/ExpenseEnvTotalDraftList.jsx";

import GeneralSalesForm from "../pages/accounting/general/GeneralSalesForm";
import GeneralSalesList from "../pages/accounting/general/GeneralSalesList";
import GeneralSalesAccountForm from "../pages/accounting/accounts/GeneralSalesAccountForm";
import GeneralSalesAccountList from "../pages/accounting/accounts/GeneralSalesAccountList";
import BudgetYearlyList from "../pages/accounting/budget/BudgetYearlyList";
import BudgetYearlyNew from "../pages/accounting/budget/BudgetYearlyNew";
import BankAccountRegister from "../pages/accounting/bank/BankAccountRegister";

import DailyWorkerEvaluation from "../pages/hreval/DailyWorkerEvaluation";
import ContractWorkerEvaluation from "../pages/hreval/ContractWorkerEvaluation";

import StaffContacts from "../pages/StaffContacts";
import Vendors from "../pages/etc/Vendors";
import WebsiteList from "../pages/etc/website/WebsiteList";
import ExpenseUsageCodes from "../pages/etc/ExpenseUsageCodes";
import MailAlertPage from "../pages/etc/mailAlert/MailAlertPage";
import CalendarV2 from "../pages/CalendarV2";
import CalendarAdmin from "../pages/CalendarAdmin";
import HolidayManage from "../pages/HolidayManage";
import WorkSchedule from "../pages/WorkSchedule";
import CafeExpenseLedger from "../pages/cafe/CafeExpenseLedger";
import IncomeStatus from "../pages/etc/IncomeStatus";
import ExpenseStatus from "../pages/etc/ExpenseStatus";
import TotalStatus from "../pages/etc/TotalStatus";
import InsuranceAllocation from "../pages/etc/InsuranceAllocation";
import InsuranceAnnualSummary from "../pages/etc/InsuranceAnnualSummary";

import TaxTable from "../pages/payroll/TaxTable";
import WageRates from "../pages/payroll/WageRates";
import InsuranceRateManage from "../pages/payroll/InsuranceRateManage";
import PayrollSheet from "../pages/payroll/PayrollSheet";

import WelfarePoint from "../pages/welfare/WelfarePoint";

import GisungContracts from "../pages/gisung_gye/GisungContracts";
import GisungGenerate from "../pages/gisung_gye/GisungGenerate";
import GisungHistory from "../pages/gisung_gye/GisungHistory";

import QuotationList from "../pages/quotation/QuotationList";
import QuotationForm from "../pages/quotation/QuotationForm";

import DailyTodoList from "../pages/DailyTodo/DailyTodoList";
import TeamMeetingView from "../pages/DailyTodo/TeamMeetingView";
import CompletionRateStats from "../pages/DailyTodo/CompletionRateStats";

import EvaluationManualList from "../pages/evaluation/EvaluationManualList";

import RentalOrderList from "../pages/rental/RentalOrderList.jsx";
import RentalSales from "../pages/rental/RentalSales.jsx";
import AirconReservationList from "../pages/aircon/AirconReservationList.jsx";
import TeamLeaderManualPage from "../pages/ManualGuide/TeamLeaderManualPage";

// ✅ path + element(이미 필요한 props까지 포함된 JSX) 쌍의 배열. App.js는 이 배열을
// <Route>로 그대로 매핑하고, AppLayout.jsx는 같은 배열을 keep-alive 후보로 쓴다.
export const PROTECTED_ROUTES = [
  { path: "/mypage", element: <MyPage /> },
  { path: "/dashboard", element: <Dashboard /> },

  { path: "/task/assign/new", element: <TaskAssignNew /> },
  { path: "/task/assign/list", element: <TaskAssignList /> },
  { path: "/task/received/list", element: <TaskReceivedList /> },
  { path: "/task/by-employee", element: <TaskByEmployee /> },
  { path: "/task/chat", element: <TaskChatPage /> },

  { path: "/work-performance", element: <WorkPerformanceQuickPage /> },
  { path: "/work-performance/quick", element: <WorkPerformanceQuickPage /> },
  { path: "/work-performance/summary", element: <WorkPerformanceSummaryPage /> },
  { path: "/work-performance/dashboard", element: <WorkPerformanceDashboardPage /> },

  { path: "/edu/job", element: <EduJob /> },
  { path: "/edu/youtube", element: <EduYoutube /> },
  { path: "/edu/legal", element: <EduLegal /> },
  { path: "/edu/cert", element: <EduCert /> },

  { path: "/approval/expense-draft/new", element: <ExpenseDraftNew /> },
  { path: "/approval/income-draft/new", element: <IncomeDraftNew /> },
  { path: "/approval/income-resolution/new", element: <IncomeResolutionNew /> },
  { path: "/approval/expense-resolution/new", element: <ExpenseResolutionNew /> },
  { path: "/approval/draftdocument/list", element: <DraftDocumentList /> },
  { path: "/approval/resolution-list", element: <ResolutionList /> },
  { path: "/approval/inbox", element: <ApprovalInbox /> },
  { path: "/approval/done", element: <ApprovalInbox /> },
  { path: "/approval/inprogress", element: <ApprovalInProgress /> },
  { path: "/approval/cc", element: <ApprovalCc /> },
  { path: "/approval/leave/new", element: <LeaveRequestNew /> },
  { path: "/approval/leave/list", element: <LeaveRequestList /> },

  { path: "/income/business/new", element: <IncomeBusinessNew /> },
  { path: "/income/business/list", element: <IncomeBusinessList /> },
  { path: "/income/service/new", element: <IncomeServiceNew /> },
  { path: "/income/service/list", element: <IncomeServiceList /> },
  { path: "/income/cafe/gasan/new", element: <GasanIncomeCreate /> },
  { path: "/income/cafe/gasan/list", element: <GasanIncomeList /> },
  { path: "/income/cafe/doksan/new", element: <DoksanIncomeCreate /> },
  { path: "/income/cafe/doksan/list", element: <DoksanIncomeList /> },
  { path: "/income/cafe/geumnarae/new", element: <GeumnaraeIncomeCreate /> },
  { path: "/income/cafe/geumnarae/list", element: <GeumnaraeIncomeList /> },
  { path: "/income/cafe/green/new", element: <GreenIncomeCreate /> },
  { path: "/income/cafe/green/list", element: <GreenIncomeList /> },
  { path: "/income/env/disinfection/new", element: <IncomeEnvDisinfectionNew /> },
  { path: "/income/env/disinfection/list", element: <EnvDisinfectionList /> },
  { path: "/income/env/disinfection/invoice", element: <DisinfectionInvoicePage /> },
  { path: "/income/env/total/new", element: <IncomeEnvTotalNew /> },
  { path: "/income/env/total/list", element: <EnvTotalList /> },

  { path: "/expense/business/new", element: <ExpenseBusinessNew /> },
  { path: "/expense/business/list", element: <ExpenseBusinessList /> },
  { path: "/expense/business/draft/new", element: <ExpenseBusinessDraftNew /> },
  { path: "/expense/business/draft/list", element: <ExpenseBusinessDraftList /> },
  // ✅ 수입데이터+수입기안 통합 작성 [파일럿]
  { path: "/income/business/draft/new", element: <IncomeBusinessDraftNew /> },
  { path: "/income/business/draft/list", element: <IncomeBusinessDraftList /> },
  // ✅ 수입데이터+수입기안 통합 작성 [2단계] — 환경/종합
  { path: "/income/env/total/draft/new", element: <IncomeEnvTotalDraftNew /> },
  { path: "/income/env/total/draft/list", element: <IncomeEnvTotalDraftList /> },
  // ✅ 수입데이터+수입기안 통합 작성 [3단계] — 환경/소독
  { path: "/income/env/disinfection/draft/new", element: <IncomeEnvDisinfectionDraftNew /> },
  { path: "/income/env/disinfection/draft/list", element: <IncomeEnvDisinfectionDraftList /> },
  // ✅ 수입데이터+수입기안 통합 작성 [4단계] — 용역사업
  { path: "/income/service/draft/new", element: <IncomeServiceDraftNew /> },
  { path: "/income/service/draft/list", element: <IncomeServiceDraftList /> },
  { path: "/expense/test/new", element: <ExpenseTestNew /> },
  { path: "/expense/test/list", element: <ExpenseTestList /> },
  { path: "/expense/service/new", element: <ExpenseServiceNew /> },
  { path: "/expense/service/list", element: <ExpenseServiceList /> },
  { path: "/expense/service/draft/new", element: <ExpenseServiceDraftNew /> },
  { path: "/expense/service/draft/list", element: <ExpenseServiceDraftList /> },
  { path: "/expense/cafe/gasan/new", element: <ExpenseCafeGasanNew /> },
  { path: "/expense/cafe/gasan/list", element: <ExpenseCafeGasanList /> },
  { path: "/expense/cafe/gasan/draft/new", element: <ExpenseCafeGasanDraftNew /> },
  { path: "/expense/cafe/gasan/draft/list", element: <ExpenseCafeGasanDraftList /> },
  { path: "/expense/cafe/doksan/new", element: <ExpenseCafeDoksanNew /> },
  { path: "/expense/cafe/doksan/list", element: <ExpenseCafeDoksanList /> },
  { path: "/expense/cafe/doksan/draft/new", element: <ExpenseCafeDoksanDraftNew /> },
  { path: "/expense/cafe/doksan/draft/list", element: <ExpenseCafeDoksanDraftList /> },
  { path: "/expense/cafe/geumnarae/new", element: <ExpenseCafeGeumnaraeNew /> },
  { path: "/expense/cafe/geumnarae/list", element: <ExpenseCafeGeumnaraeList /> },
  { path: "/expense/cafe/geumnarae/draft/new", element: <ExpenseCafeGeumnaraeDraftNew /> },
  { path: "/expense/cafe/geumnarae/draft/list", element: <ExpenseCafeGeumnaraeDraftList /> },
  { path: "/expense/cafe/green/new", element: <ExpenseCafeGreenNew /> },
  { path: "/expense/cafe/green/list", element: <ExpenseCafeGreenList /> },
  { path: "/expense/cafe/green/draft/new", element: <ExpenseCafeGreenDraftNew /> },
  { path: "/expense/cafe/green/draft/list", element: <ExpenseCafeGreenDraftList /> },
  { path: "/expense/env/disinfection/new", element: <ExpenseEnvDisinfectionNew /> },
  { path: "/expense/env/disinfection/list", element: <ExpenseEnvDisinfectionList /> },
  { path: "/expense/env/disinfection/draft/new", element: <ExpenseEnvDisinfectionDraftNew /> },
  { path: "/expense/env/disinfection/draft/list", element: <ExpenseEnvDisinfectionDraftList /> },
  { path: "/expense/env/total/new", element: <ExpenseEnvTotalNew /> },
  { path: "/expense/env/total/list", element: <ExpenseEnvTotalList /> },
  { path: "/expense/env/total/draft/new", element: <ExpenseEnvTotalDraftNew /> },
  { path: "/expense/env/total/draft/list", element: <ExpenseEnvTotalDraftList /> },

  { path: "/accounting/general/sales/new", element: <GeneralSalesForm /> },
  { path: "/accounting/general/sales/list", element: <GeneralSalesList /> },
  { path: "/accounting/accounts/sales/new", element: <GeneralSalesAccountForm /> },
  { path: "/accounting/accounts/sales-list", element: <GeneralSalesAccountList /> },
  { path: "/accounting/budget/yearly/list", element: <BudgetYearlyList /> },
  { path: "/accounting/budget/yearly/new", element: <BudgetYearlyNew /> },
  { path: "/accounting/bank/register", element: <BankAccountRegister /> },

  { path: "/hreval/list", element: <DailyWorkerEvaluation /> },
  { path: "/hreval/contract", element: <ContractWorkerEvaluation /> },

  { path: "/etc/staff-contacts", element: <StaffContacts /> },
  { path: "/etc/vendors", element: <Vendors /> },
  { path: "/etc/websites", element: <WebsiteList /> },
  { path: "/etc/expense-usage-codes", element: <ExpenseUsageCodes /> },
  { path: "/etc/mail-alert", element: <MailAlertPage /> },
  { path: "/etc/calendar/general", element: <CalendarV2 /> },
  { path: "/etc/calendar/v2", element: <CalendarV2 /> },
  { path: "/etc/calendar/admin", element: <CalendarAdmin /> },
  { path: "/etc/holiday/manage", element: <HolidayManage /> },
  { path: "/work-schedule", element: <WorkSchedule /> },
  { path: "/cafe/expense-ledger", element: <CafeExpenseLedger /> },
  { path: "/etc/income-status", element: <IncomeStatus /> },
  { path: "/etc/expense-status", element: <ExpenseStatus /> },
  { path: "/etc/total-status", element: <TotalStatus /> },
  { path: "/etc/insurance-allocation", element: <InsuranceAllocation /> },
  { path: "/etc/insurance-annual", element: <InsuranceAnnualSummary /> },

  { path: "/payroll/tax-table", element: <TaxTable /> },
  { path: "/payroll/wage-rates", element: <WageRates /> },
  { path: "/payroll/insurance-rates", element: <InsuranceRateManage /> },
  { path: "/payroll/sheet", element: <PayrollSheet /> },

  { path: "/welfare/point", element: <WelfarePoint /> },

  { path: "/gisung-gye/contracts", element: <GisungContracts /> },
  { path: "/gisung-gye/guchung", element: <GisungGenerate type="구청" /> },
  { path: "/gisung-gye/gongdan", element: <GisungGenerate type="공단" /> },
  { path: "/gisung-gye/history", element: <GisungHistory /> },

  { path: "/quotation/list", element: <QuotationList /> },
  { path: "/quotation/new", element: <QuotationForm /> },
  { path: "/quotation/:id/edit", element: <QuotationForm /> },

  { path: "/daily-todo", element: <DailyTodoList /> },
  { path: "/daily-todo/meeting", element: <TeamMeetingView /> },
  { path: "/daily-todo/stats", element: <CompletionRateStats /> },

  { path: "/evaluation/manuals", element: <EvaluationManualList /> },

  { path: "/manual-guide", element: <TeamLeaderManualPage /> },

  // ✅ 금천아 빌려줘 (카페24 대여 주문) — 상세(:id)는 동적 라우트라 App.js에 있다.
  { path: "/rental/orders", element: <RentalOrderList /> },
  { path: "/rental/sales", element: <RentalSales /> },
  { path: "/aircon/reservations", element: <AirconReservationList /> },
];

// ✅ 이번 확대에서 제외한 동적(:id) 라우트 — 위 주석 참고. 참고용 목록(코드에서 실제
// 쓰이진 않음, App.js에 여전히 개별 선언돼 있고 기존과 동일하게 동작함).
export const EXCLUDED_DYNAMIC_ROUTES = [
  "/rental/orders/:id",
  "/approval/draftdocument/:id/edit",
  "/approval/draftdocument/:id",
  "/accounting/budget/yearly/:id",
  "/evaluation/manuals/:id/viewer",
  "/evaluation/manuals/:id/indicators",
];

// ✅ 무거운 페이지 블랙리스트 — keep-alive 대상에서 제외(화면은 그대로 렌더되지만
// 탭 전환 시 기존처럼 언마운트/재마운트된다). FullCalendar는 컨테이너가
// display:none이던 시점의 크기를 그대로 기억해버리는 고질적 리사이즈 버그가 있어
// (숨겨졌다 다시 보일 때 레이아웃이 깨짐), 안전하게 제외했다.
export const KEEP_ALIVE_EXCLUDE = [
  "/etc/calendar/general",  // CalendarV2 → FullCalendar
  "/etc/calendar/v2",       // CalendarV2 → FullCalendar
  "/work-schedule",         // WorkSchedule → FullCalendar
];
